import { t } from '@lingui/core/macro';
import { styled } from '@mui/material';
import { XIcon } from 'lucide-react';
import { closeSnackbar, SnackbarKey } from 'notistack';

import { colorSystem } from '../../theme';
import { TertiaryIconButton } from '../buttons';

const StyledCloseButton = styled(TertiaryIconButton)({
    color: colorSystem.neutral['white'],
    '&:hover': {
        background: 'none',
        color: colorSystem.neutral[3],
    },
    '&:active': {
        background: 'none',
        color: colorSystem.neutral[4],
    },
    // The snackbar is green, red or yellow 8 or neutral 9, on which the theme's blue ring would barely show.
    '&.Mui-focusVisible': {
        outlineColor: colorSystem.neutral.white,
    },
});

export function SnackbarCloseButton({ snackbarKey }: { snackbarKey: SnackbarKey }): JSX.Element {
    return (
        <StyledCloseButton
            className="snackbar-close-button"
            size="small"
            aria-label={t`Close`}
            onClick={() => closeSnackbar(snackbarKey)}
        >
            <XIcon />
        </StyledCloseButton>
    );
}
